import { DynamoKey } from "./BaseDynamoClass";
import { UnderscoreKeys } from "../util/Types";
import { BasicError } from "./BasicError";
import { User, UserPKInput } from "./User";
import { UserOwnedClass, UserOwnedFields } from "./UserOwnedClass";

export type SupportRequestFields = UserOwnedFields & {
	supportRequestId: string;
	parentTable: string;
    requestType : "support";
	emailAddress: string;
	firstName: string;
	orderRef?: string;
	message: string;
};
export class SupportRequest<TFields extends SupportRequestFields = SupportRequestFields> extends UserOwnedClass<TFields> {
	_supportRequestId!: string;
	_parentTable!: string;
    _requestType! : "support";
	_emailAddress!: string;
	_firstName!: string;
	_orderRef?: string;
	_message!: string;

	override _className: string = "SupportRequest";
	override _deserializeClassName: string = "SupportRequest";

	override getFieldList(): (keyof UnderscoreKeys<TFields>)[] {
		return [...super.getFieldList(), "_supportRequestId", "_parentTable", "_emailAddress", "_firstName", "_orderRef", "_message"];
	}
	constructor(props: Partial<TFields>) {
		super(props);
	}
	get supportRequestId(): string {
		return this.checkFieldType<"supportRequestId">(this._supportRequestId);
	}
	set supportRequestId(value: string) {
		this._supportRequestId = this.checkFieldTypeAndMark<"supportRequestId">("_supportRequestId", value);
	}

	get parentTable(): string {
		return this.checkFieldType<"parentTable">(this._parentTable);
	}
	set parentTable(value: string) {
		this._parentTable = this.checkFieldTypeAndMark<"parentTable">("_parentTable", value);
	}

	get emailAddress(): string {
		return this.checkFieldType<"emailAddress">(this._emailAddress);
	}
	set emailAddress(value: string) {
		this._emailAddress = this.checkFieldTypeAndMark<"emailAddress">("_emailAddress", value);
	}

	get firstName(): string {
		return this.checkFieldType<"firstName">(this._firstName);
	}
	set firstName(value: string) {
		this._firstName = this.checkFieldTypeAndMark<"firstName">("_firstName", value);
	}

	get orderRef(): string | undefined {
		return this.checkFieldType<"orderRef">(this._orderRef);
	}
	set orderRef(value: string | undefined) {
		this._orderRef = this.checkFieldTypeAndMark<"orderRef">("_orderRef", value);
	}

	get message(): string {
		return this.checkFieldType<"message">(this._message);
	}
	set message(value: string) {
		this._message = this.checkFieldTypeAndMark<"message">("_message", value);
	}

	get requestType(): "support" {
		return this.checkFieldType<"requestType">(this._requestType);
	}
	set requestType(value: "support") {
		this._requestType = this.checkFieldTypeAndMark<"requestType">("_requestType", value);
	}

	getPKPrefix(): string {
		return "USER#";
	}
	getSKPrefix(): string {
		return "SUPPORTREQUEST#";
	}
	getPK(): string {
		return this.getPKPrefix() + this.userId;
	}
	getSK(): string {
		return this.getSKPrefix() + this._supportRequestId;
	}
	getParentKey(): DynamoKey | undefined {
		return User.generateKey({ userId: this.userId });
	}
	getParentKeyInput(): UserPKInput | undefined {
		if (!this.userId) throw new BasicError("Missing userId", "Missing userId");
		return { userId: this.userId };
	}
	getParentTableName(): string | undefined {
		return this._parentTable;
	}
	generateKey(): DynamoKey {
		return {
			PK: this.getPK(),
			SK: this.getSKPrefix() + this._supportRequestId,
		};
	}
	generatePK(input: UserPKInput): string {
		return this.getPKPrefix() + input.userId;
	}
	generateGSIPK(): string {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	generateGSISK(): string {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	getGlobalIndices(): object {
		return {};
	}
	getColumnsForExport(): string[] {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
	getObjectForExport(): object {
		throw new BasicError("Not implemented", "Method not implemented.");
	}
}
